<template>
    <div>
        <Plus v-if="icon === 'easyRestaurantManager-plus'" />
        <Cancel v-if="icon === 'easyRestaurantManager-cancel'" />
        <Edit v-if="icon === 'easyRestaurantManager-edit'" />
        <Delete v-if="icon === 'easyRestaurantManager-delete'" />
        <Eye v-if="icon === 'easyRestaurantManager-eye'" />
        <Money v-if="icon === 'easyRestaurantManager-money'" />
        <Pending v-if="icon === 'easyRestaurantManager-pending'" />
    </div>

  </template>
  

<script>
import Plus from "./Plus.vue";
import Cancel from "./Cancel.vue";
import Edit from "./Edit.vue";
import Delete from "./Delete.vue";
import Eye from "./Eye.vue";
import Money from "./Money.vue";
import Pending from "./PendingIcon.vue";

export default {
    components: {
        Plus,
        Cancel,
        Edit,
        Delete,
        Eye,
        Money,
        Pending
    },
    props: {
        icon: {
            type: String,
        }
    }
}
</script>